import * as Sentry from '@sentry/react';
import { App } from 'components/app';
import { unstable_HistoryRouter as Router } from 'react-router-dom';
import { IntlProvider } from '../intl-provider';
import { LaunchDarklyInitializer } from 'components/launch-darkly';
import { MiniappSdkProvider } from 'components/miniapp-sdk-provider';
import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { RootStyles } from './root.styles';
import { history } from 'store/router/history';
import store from 'store';
import { ErrorPageWithNoDependencies } from 'pages/error/components/error-with-no-dependencies';
import 'init/initIcons';
import { ErrorPage } from 'pages/error';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BundleUpdateManager } from 'components/bundle-update-manager';
import { ToastProvider } from '@hqo/toast';

import 'init/sentry';

const queryClient = new QueryClient();

export const Root: React.FC = Sentry.withProfiler(() => (
  <Sentry.ErrorBoundary fallback={<ErrorPageWithNoDependencies />}>
    <ReduxProvider store={store}>
      <MiniappSdkProvider>
        <LaunchDarklyInitializer>
          <Router history={history}>
            <IntlProvider>
              <RootStyles />
              {/* RES-1076: mounted once here so `toast.success`/`toast.error` (from '@hqo/toast')
                  work anywhere in the tree, same pattern resource-booking-admin uses at its own
                  root. `useSonnerToasts` enables @hqo/toast's sonner backend (sonner is a real
                  dependency of @hqo/toast itself, see its package.json — nothing extra to install
                  here). Its className-based theming (system-green/system-pink/etc., see
                  @hqo/toast's SONNER_TOAST_CLASSNAMES) resolves through the Tailwind v4 entry
                  in src/app.css, which @source-scans @hqo/toast (VIS-2144). */}
              <ToastProvider useSonnerToasts />
              <Sentry.ErrorBoundary fallback={<ErrorPage />}>
                <QueryClientProvider client={queryClient}>
                  <App />
                  <BundleUpdateManager />
                  <ReactQueryDevtools position="right" initialIsOpen={false} />
                </QueryClientProvider>
              </Sentry.ErrorBoundary>
            </IntlProvider>
          </Router>
        </LaunchDarklyInitializer>
      </MiniappSdkProvider>
    </ReduxProvider>
  </Sentry.ErrorBoundary>
));
